import React, { Component, PureComponent } from "react"
import { connect } from "react-redux"
import ModalDialog from "../ModalDialog"
import { withTranslation } from "react-i18next"
import { isEmpty, sortBy } from "lodash"
import translate from "translate"
import {
  GRUBHUB,
  INSTACART,
  INSTACART_CA,
  INSTACART_CANADA,
  UBER,
  UBER_CA,
  UBER_CANADA
} from "../../constants/affiliations"
import UberMembershipBenefits from "../../../v2/components/UberMembershipBenefits"
import instacartNewLogo from "../../../images/instacart_new_logo.svg"
import grubhubNewLogo from "../../../images/grubhub_new_logo.svg"
import uberLogo from "../../../images/uber_logo.svg"
import step1Image from "../../../images/step_1.svg"
import step2Image from "../../../images/step_2.svg"
import step3Image from "../../../images/step_3.svg"
import uberCar from "../../../images/uber-car.svg"
import caChevronRight from "../../../images/ca-chevron-right.svg"
import caLogoWhite from "../../../images/CarAdvise-LogoWhite.svg"
import { Icon } from "semantic-ui-react"
import DOMPurify from "dompurify"
import { getSubdomain } from "../Config/StylesheetInjector"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCheck } from "@fortawesome/pro-regular-svg-icons"

function TierBubble({ name, selected, upperCase, color }) {
  return (
    <div
      className={selected ? "tier-bubble-selected" : "tier-bubble"}
      style={color && { color: color }}
    >
      <span>{upperCase ? name.toUpperCase() : name}</span>
    </div>
  )
}

class AffiliationSiblingModal extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      bubble_text: "",
      translated_descriptions: [],
      showBenefitsModal: false
    }
  }

  async translated_description() {
    let { user } = this.props
    let { displays_siblings_to_customer, siblings, bubble_text } = this.props.affiliation
    let all = [this.props.affiliation]
    if (displays_siblings_to_customer) all = all.concat(siblings)
    var descriptions_array = []
    all = sortBy(all, "sibling_order_preference")
    if (user.language.includes("fr")) {
      translate.engine = process.env.REACT_APP_TRANSLATION_SOURCE
      translate.key = process.env.REACT_APP_TRANSLATION_SOURCE_ID

      all.map(async (affiliation, i) => {
        descriptions_array.push(await translate(affiliation.customer_facing_description, "fr"))
      })
      const bubble_text_fr = await translate(bubble_text, "fr")
      // const translated_descriptions=await translate(customer_array_descriptions, "fr");
      this.setState({ bubble_text: bubble_text_fr, translated_descriptions: descriptions_array })
    } else {
      all.map(async (affiliation, i) => {
        descriptions_array.push(affiliation.customer_facing_description)
      })
      this.setState({ bubble_text: bubble_text, translated_descriptions: descriptions_array })
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps && prevProps.affiliation && prevProps.affiliation.customer_facing_description) {
      if (
        prevProps.affiliation.customer_facing_description !==
        this.props.affiliation.customer_facing_description
      ) {
        this.translated_description()
      }
    }

    if (isEmpty(this.state.translated_descriptions)) {
      this.translated_description()
    }
  }

  openBenefitsModal() {
    this.setState({ showBenefitsModal: true })
  }

  closeBenefitsModal = () => {
    this.setState({ showBenefitsModal: false })
  }

  AffiliationLogo = () => {
    if ([UBER, UBER_CANADA, UBER_CA].includes(this.props.user?.affiliation?.root_reference_id)) {
      return uberLogo
    }

    if ([INSTACART, INSTACART_CANADA].includes(this.props.user?.affiliation?.root_reference_id)) {
      return instacartNewLogo
    }

    if (this.props.user?.affiliation?.root_reference_id === GRUBHUB) {
      return grubhubNewLogo
    }

    return
  }

  render() {
    let {
      name,
      siblings,
      displays_siblings_to_customer,
      bubble_text,
      bubble_text_color
    } = this.props.affiliation
    let all = [this.props.affiliation]
    const { t, isNewbanner = false, affilationName } = this.props
    if (displays_siblings_to_customer) all = all.concat(siblings)

    all = sortBy(all, "sibling_order_preference")

    if (affilationName && affilationName.toLowerCase().includes(UBER)) {
      return (
        <>
          <a
            className={`affilation-card-button ${affilationName}-card-button`}
            onClick={() => this.openBenefitsModal()}
          >
            {t("justForYouCards:checkThemOut")}
          </a>
          <UberMembershipBenefits
            isOpen={this.state.showBenefitsModal}
            closeModal={this.closeBenefitsModal}
          />
        </>
      )
    }

    const steps = [
      {
        id: 1,
        title: "Search for services for your vehicle",
        icon: (
          <div className="icon-circle">
            <img src={step1Image} />
          </div>
        )
      },
      {
        id: 2,
        title: "See discounts applied at checkout",
        icon: (
          <div className="icon-circle">
            <img src={step2Image} />
          </div>
        )
      },
      {
        id: 3,
        title: "Book your appointment",
        icon: (
          <div className="icon-circle">
            <img src={step3Image} />
          </div>
        )
      }
    ]
    const benefitsListInstaCartUS = [
      {
        name: "Instacart Diamond",
        benefits: ["75% off an oil change<sup>1</sup> "],
        key: "diamond"
      },
      {
        name: "Instacart Platinum",
        benefits: ["50% off an oil change<sup>1</sup>"],
        key: "platinum"
      },
      {
        name: "Instacart Gold",
        benefits: ["25% off an oil change<sup>1</sup>"],
        key: "gold"
      },
      {
        name: "Instacart No Tier",
        benefits: ["Get 10% off all maintenance needs<sup>2</sup>"],
        key: "no tier"
      }
    ]
    const benefitsListInstaCartCanada = [
      {
        name: "Instacart Diamond",
        benefits: [
          "<p>75% off an oil change<sup>1,2</sup></p> <p>Get 10% off other maintenance needs, up to $50 in savings<sup>3</sup></p>"
        ],
        key: "diamond"
      },
      {
        name: "Instacart Platinum",
        benefits: [
          "<p>50% off an oil change<sup>1,2</sup></p> <p>Get 10% off other maintenance needs, up to $50 in savings<sup>3</sup></p>"
        ],
        key: "platinum"
      },
      {
        name: "Instacart Gold",
        benefits: [
          "<p>25% off an oil change<sup>1,2</sup></p> <p>Get 10% off other maintenance needs, up to $50 in savings<sup>3</sup></p>"
        ],
        key: "gold"
      },
      {
        name: "Instacart No Tier",
        benefits: ["<p>Get 10% off other maintenance needs, up to $50 in savings<sup>3</sup></p>"],
        key: "no tier"
      }
    ]

    const SafeHtmlText = ({ text, style }) => {
      const hasHtml = /<\/?[a-z][\s\S]*>/i.test(text)

      if (hasHtml) {
        const cleanHtml = DOMPurify.sanitize(text)
        return <span style={style} dangerouslySetInnerHTML={{ __html: cleanHtml }} />
      }

      return <span style={style}>{text}</span>
    }
    const getBenefitsItem = (plan) => {
      return (
        <div className="benefit-card">
          <div className="benefit-card-header">
            <div className="title">{plan.name}</div>
          </div>
          <div className="benefit-item">
            <img src={caChevronRight} />
            <SafeHtmlText text={plan.benefits} style={{ textAlign: "left", fontSize: "medium" }} />
          </div>
        </div>
      )
    }
    const getBenefitsHeader = (plan) => {
      return (
        <div className="benefit-card your-tier-card">
          <div className="benefit-card-header">
            <div className="title">{plan.name}</div>
            <div className="your-tier-text">
              <Icon name="check" />
              <div className="your-tier-title">Your Tier</div>
            </div>
          </div>

          <div className="benefit-item">
            <img src={caChevronRight} />
            <SafeHtmlText text={plan.benefits} style={{ textAlign: "left", fontSize: "medium" }} />
          </div>
        </div>
      )
    }
    return (
      <ModalDialog
        contentClassName={"affiliation-modal-content modal-no-buttons"}
        chromeless={true}
        customElement={
          isNewbanner ? (
            <a className={`affilation-card-button ${affilationName}-card-button`}>
              {t("justForYouCards:checkThemOut")}
            </a>
          ) : (
            <TierBubble
              name={displays_siblings_to_customer ? name : this.state.bubble_text}
              color={bubble_text_color}
              upperCase={displays_siblings_to_customer}
            />
          )
        }
      >
        <h2 style={{ marginTop: "0" }}>Membership Benefits</h2>
        <img src={this.AffiliationLogo()} height={"30px"} width={"190px"} />
        <div className="step-container">
          {steps.map((step, index) => (
            <div className="step-card" key={step.id}>
              <div className="step-number">{step.id}</div>
              {step.icon}
              <p>{step.title}</p>
            </div>
          ))}
        </div>
        <hr />
        {this.props.user?.affiliation?.root_reference_id === UBER && (
          <div className="drive-more-container">
            <img src={uberCar} className="uber-car" />
            <p style={{ color: "white", textAlign: "left", fontSize: "14px" }}>
              Drive more with Uber to unlock better benefits and get upgraded automatically!
            </p>
          </div>
        )}
        <div className="benefit-card-container">
          {getSubdomain() === INSTACART_CA ? (
            benefitsListInstaCartCanada.map((plan) =>
              this.props.user?.affiliation?.name.toLowerCase().includes(plan.key)
                ? getBenefitsHeader(plan)
                : getBenefitsItem(plan)
            )
          ) : getSubdomain() === INSTACART ? (
            benefitsListInstaCartUS.map((plan) =>
              this.props.user?.affiliation?.name.toLowerCase().includes(plan.key)
                ? getBenefitsHeader(plan)
                : getBenefitsItem(plan)
            )
          ) : (
            <>
              <div className="benefit-card your-tier-card">
                <div className="benefit-card-header">
                  <div className="title">{this.props.user?.affiliation?.name}</div>
                  <div className="your-tier-text">
                    <Icon name="check" />
                    <div className="your-tier-title">Your Tier</div>
                  </div>
                </div>
                {this.props.user?.affiliation?.customer_facing_description && (
                  <div className="benefit-item">
                    <img src={caChevronRight} />
                    <SafeHtmlText
                      text={this.props.user?.affiliation?.customer_facing_description}
                      style={{ textAlign: "left", fontSize: "medium" }}
                    />
                  </div>
                )}
              </div>

              {this.props.user?.affiliation?.siblings?.map((sibling) => (
                <div key={sibling.name} className="benefit-card">
                  <div className="title">{sibling.name}</div>
                  {sibling.customer_facing_description && (
                    <div className="benefit-item">
                      <img src={caChevronRight} />
                      <SafeHtmlText
                        text={sibling.customer_facing_description}
                        style={{ textAlign: "left", fontSize: "medium" }}
                      />
                    </div>
                  )}
                </div>
              ))}
            </>
          )}
        </div>

        <div className="terms-and-conditions">
          {getSubdomain() === INSTACART_CA ? (
            <>
              <p style={{ marginTop: 2 }}>
                <sup>1</sup> Once per calendar quarter (Jan - Mar, Apr - Jun, Jul - Sept, Oct -
                Dec).
              </p>
              <p style={{ marginTop: 2 }}>
                <sup>2</sup> $50 cap does not apply to oil change perks.
              </p>
              <p style={{ marginTop: 2 }}>
                <sup>3</sup> Savings subject to change.
              </p>
            </>
          ) : getSubdomain() === INSTACART ? (
            <>
              <p style={{ marginTop: 2 }}>
                <sup>1</sup> Once per calendar quarter (Jan - Mar, Apr - Jun, Jul - Sept, Oct -
                Dec).
              </p>
              <p style={{ marginTop: 2 }}>
                <sup>2</sup> Savings subject to change.
              </p>
            </>
          ) : (
            <>
              <p style={{ margin: 0 }}>*Savings subject to change</p>
              <p style={{ margin: 0 }}>**One use per calendar quarter</p>
            </>
          )}
        </div>
        <div className="ca-logo-container">
          <img src={caLogoWhite} width="161px" />
        </div>
      </ModalDialog>
    )
  }
}

function mapStateToProps(state, props) {
  let user = state.user || {}
  let affiliation = user.affiliation || {}

  return {
    affiliation,
    user
  }
}

export default connect(
  mapStateToProps,
  {}
)(withTranslation(["affiliationSiblingModal", "justForYouCards"])(AffiliationSiblingModal))
